/**
 * Find the ad account with the given ID.
 * @param accounts Accounts to search through
 * @param accountId The account ID to match
 * @returns The found account or undefined
 */
export const findAccountById = (accounts, accountId) => {
  return accounts.find(account => account.accountId === accountId);
};
/**
 * Determine if the given account has accepted Google's EC4L data terms.
 * @param account
 * @returns True or false
 */

export const hasAcceptedGoogleECDataTerms = account => {
  return account.conversionTrackingInfo && account.conversionTrackingInfo.enhancedConversionsForLeadsEnabled && account.conversionTrackingInfo.hasAcceptedTermsOfService;
};